/**
 * Media types
 *
 * @type {string[]}
 */
export const TYPES = ['image', 'screenshot', 'video'];

export default {};
